/**
 * Error levels for client error reporting
 */

export const CLIENT_ERROR_LEVEL_ERROR = 'ERROR';
export const CLIENT_ERROR_LEVEL_WARNING = 'WARNING';
